import React from 'react';
import { useAuth } from './hooks/useAuth';
import Dashboard from './components/Dashboard';
import AuthPage from './components/AuthPage';
import BugReporterOverlay from './components/BugReporterOverlay';
import './App.css';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <h2>🐝 Beebase Pro</h2>
          <p>Loading your beekeeping dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {user ? <Dashboard /> : <AuthPage />}
      <BugReporterOverlay />
    </div>
  );
}

export default App;
